import React from "react";

export const PageHeader = ({ title, subtitle, actions, breadcrumb, testId }) => (
  <header
    data-testid={testId || "page-header"}
    className="flex flex-wrap items-end justify-between gap-3 border-b border-line bg-paper px-6 py-4"
  >
    <div className="min-w-0">
      {breadcrumb}
      <h1 className="text-[20px] font-semibold leading-tight tracking-[-0.02em] text-ink">
        {title}
      </h1>
      {subtitle && <p className="mt-1 text-[13px] text-ink-secondary">{subtitle}</p>}
    </div>
    {actions && <div className="flex items-center gap-2">{actions}</div>}
  </header>
);
